import { ICustomContent } from "./ICustomConfiguration";
import * as React from 'react';

export const CustomContent: ICustomContent = {
    UserProfile: {
        RegisterBefore: undefined,
        RegisterAfter: <div className="pt-4">
            <h3>Further Information</h3>
            If you have any questions about this project, please contact us.
        </div>,
        UserAgreement: <span><p>These are the terms.</p>
        <p>If you consent to these terms, please tick the box to proceed</p></span>,
        UserAgreementCheckbox: "I agree to these terms"
    },
    Survey: {
        SubmitSuccessMessage: "Thank you. Data successfully submitted"
    }
}